module.exports = __webpack_public_path__ + "static/media/medical provider.4fad4e9f.png";